import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom"; // Bổ sung ReactDOM để dùng Portal
import Footer from "../components/Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function Notification() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [isShow, setShow] = useState(false);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [notifyItem, setNotifyItem] = useState();
    
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    
    const navigate = useNavigate();
    
    const handleBackClick = () => {
        navigate(-1);
    };
    
    useEffect(() => {
        const token = localStorage.getItem("user");
        if (token) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                .then((res) => {
                    if (profile !== res.data.data) {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    }
                })
                .catch((err) => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("profile");
                    setProfile(null);
                });
        }

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {})
            .then((res) => {
                if (res.data && res.data.data) {
                    setNotify(res.data.data);
                    localStorage.setItem("notify", JSON.stringify(res.data.data));
                }
            })
            .catch(err => console.error("Lỗi lấy thông báo:", err));
    }, []);

    // HÀM RENDER POPUP BẰNG PORTAL
    const renderPopup = () => {
        if (!isShow || !notifyItem) return null;

        return ReactDOM.createPortal(
            <div className="popup-backdrop" onClick={() => setShow(false)}>
                <div className="popup-main" onClick={(e) => e.stopPropagation()}>
                    <div className="popup-header">
                        {notifyItem.title.replace("}", "").replace("{", "")}
                    </div>
                    
                    <div className="popup-content hide-scrollbar">
                        {notifyItem.content.indexOf("{") !== -1 && notifyItem.content.indexOf("}") !== -1 ? (
                            <img
                                alt="notification content"
                                src={notifyItem.content.substring(notifyItem.content.indexOf("{") + 1, notifyItem.content.indexOf("}"))}
                            />
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: notifyItem.content }} />
                        )}
                    </div>
                    
                    <button onClick={() => setShow(false)} className="popup-close">
                        Đóng Lại
                    </button>
                </div>
            </div>,
            document.body // Gắn popup trực tiếp vào thẻ body
        );
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#fdfdfd" }}>
            <style dangerouslySetInnerHTML={{__html: `
                .hide-scrollbar::-webkit-scrollbar { display: none; }
                .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

                .app-main-container {
                    position: fixed;
                    top: 0;
                    bottom: 60px;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    max-width: 540px;
                    display: flex;
                    flex-direction: column;
                    background: #f4f5f7;
                    z-index: 10;
                    box-shadow: 0 0 10px rgba(0,0,0,0.05);
                }
                
                .title-top-fixed {
                    flex-shrink: 0;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    padding: 8px 15px; 
                    height: 48px; 
                    border-bottom: 1px solid #eaeaea;
                    z-index: 20;
                    position: relative; 
                }
                .title-top-fixed .back {
                    cursor: pointer;
                    color: #555;
                    display: flex;
                    align-items: center;
                    position: absolute; 
                    left: 15px;
                }
                .title-top-fixed .back svg {
                    font-size: 30px; 
                }
                .title-top-fixed .title-h1 {
                    flex: 1;
                    text-align: center;
                    margin: 0;
                    font-size: 15px; 
                    font-weight: 700;
                    color: #333;
                    text-transform: uppercase;
                }

                .scrollable-content-wrapper {
                    flex: 1;
                    overflow-y: auto;
                    background: #f4f5f7;
                    padding: 12px;
                }

                .box-image {
                    background: #fff;
                    border-radius: 8px; 
                    overflow: hidden;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                    margin-bottom: 12px;
                    cursor: pointer;
                    border: 1px solid #eaeaea;
                    transition: transform 0.2s;
                }
                .box-image:active {
                    transform: scale(0.98);
                }
                .box-image img {
                    width: 100%;
                    height: auto;
                    display: block;
                }
                .box-image-title {
                    padding: 10px 15px;
                    font-size: 13px;
                    font-weight: bold;
                    color: #333;
                    text-align: center;
                }

                /* === STYLE CHUẨN CHO POPUP DÙNG PORTAL === */
                .popup-backdrop {
                    position: fixed;
                 
                    background: rgba(0,0,0,0.6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 999999; /* Luôn cao nhất */
                    padding: 15px;
                    animation: fadeIn 0.2s ease-out;
                }
                .popup-main {
                    background: #fff;
                    border-radius: 12px;
                    width: 100%;
                    max-width: 400px;
                    max-height: 80vh; 
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                    animation: zoomIn 0.2s ease-out;
                }
                .popup-header {
                    padding: 15px;
                    background: #fff;
                    color: #333;
                    font-weight: bold;
                    text-align: center;
                    font-size: 16px;
                    border-bottom: 1px solid #eaeaea;
                }
                .popup-content {
                    padding: 15px;
                    overflow-y: auto; 
                    flex: 1;
                }
                .popup-content img {
                    width: 100%;
                    height: auto;
                    border-radius: 8px;
                    display: block;
                }
                .popup-close {
                    background: #f4f5f7;
                    color: #ff9800; 
                    border: none;
                    padding: 15px;
                    font-weight: bold;
                    font-size: 15px;
                    cursor: pointer;
                    border-top: 1px solid #eaeaea;
                    transition: background 0.2s;
                }
                .popup-close:active {
                    background: #e8e8e8;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes zoomIn {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
            `}} />

            <div className="app-main-container">
                
                <div className="title-top-fixed">
                    <div className="back" onClick={handleBackClick}>
                        <KeyboardArrowLeftOutlinedIcon />
                    </div>
                    <h1 className="title-h1">Thông báo</h1>
                </div>

                <div className="scrollable-content-wrapper hide-scrollbar">
                    {notify != null && notify.length > 0 ? (
                        <AnimatedPage>
                            {notify.map((item, index) => (
                                <React.Fragment key={index}>
                                    {index > 1 && item.title !== "marquee" && item.title !== "popup" && item.title !== "Banner" && item.isShow === true ? (
                                        <div
                                            className="box-image"
                                            onClick={() => {
                                                if (item.title.indexOf("{") !== 0) {
                                                    setNotifyItem(item);
                                                    setShow(true);
                                                } else {
                                                    navigate(item.content.replace(/<\/?[^>]+(>|$)/g, ""));
                                                }
                                            }}
                                        >
                                            <img alt="" src={item.image} />
                                            <div className="box-image-title">
                                                {item.title.replace("}", "").replace("{", "")}
                                            </div>
                                        </div>
                                    ) : null}
                                </React.Fragment>
                            ))}
                        </AnimatedPage>
                    ) : (
                        <div style={{ textAlign: "center", padding: "30px 10px", color: "#888", fontSize: "14px" }}>
                            Chưa có thông báo nào...
                        </div>
                    )}
                </div>
            </div>

            {/* Gọi hàm render popup ở đây */}
            {renderPopup()}

            <Footer />
        </div>
    );
}

export default Notification;